<template>
  <div>
    <div v-if="$route.path === '/'" id="copyright">
      <span class="copyright-en">Copyright © Sanae Nagasaka and Yoshihiko Ueda 2021</span><br class="mobile-only"><span class="copyright-ja" v-html="$t('copyright')"></span>
    </div>
    <footer>
      <div id="footer">
        <div class="logo" :class="{en: $i18n.locale === 'en'}">
          <img v-if="$i18n.locale === 'ja'" :alt="$t('seisoka')" src="@/assets/logo/horizontal.svg"/>
          <img v-else :alt="$t('seisoka')" src="@/assets/logo/horizontal-en.svg"/>
        </div>
        <div class="description">
          <div>
            {{ $t('address') }}
          </div>

          <div class="phone">{{ $t('tel') }}</div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
footer {
  position: relative;
  margin-top: auto;
  background-color: $primary;
  height: 150px;
  width: 100%;
  .description {
    margin-right: -3px;
  }
}

#copyright {
  font-size: 10px;
  text-align: right;
  padding-bottom: 10px;
  .copyright-en {
    margin-right: 7px;
  }
}

@media (max-width: $mobile-vw - 1px) {
  #copyright {
    transform: scale(0.6);
    transform-origin: right bottom;
    width: 166.666666667%;
    margin-left: -66.666666667%;
  }
}

.logo {
  font-size: 30px;
  line-height: 1.0;
  > img {
    width: 68px;
    margin-bottom: 4px;
  }
}

#footer {
  font-size: 12px;
  line-height: 24px;
  text-align: right;
  padding: 37px 34px 0 0;
  .description {
    margin-right: auto;
  }
}

.phone {
  margin-bottom: 10px;
}

@media (min-width: $mobile-vw) {
  footer {
    height: 140px;
  }

  #copyright {
    font-size: 10px;
    letter-spacing: 0.055em;
    padding-right: 37px;
    padding-bottom: 18px;
  }

  .logo {
    font-size: 27px;
    > img {
      width: 56px;
      margin-bottom: 0;
    }
    &.en > img {
      width: 72px;
      margin-bottom: 3px;
    }
  }

  #footer {
    font-size: 13px;
    line-height: 1.5;
    text-align: right;
    padding: 28px 45px 0 0;
  }
}
</style>